import brand from '@helpers/brand';
import fonts from '@helpers/fonts';
import { Device, until } from '@helpers/media';
import styled, { css } from 'styled-components';

const Container = styled.div<{ sticky?: boolean }>`
  border-top: 1px solid ${brand.grey[80]};
  padding: 16px 0px 20px 0px;
  background-color: ${brand.grey['97']};
  position: relative;

  &:last-child {
    border-bottom: 1px solid ${brand.grey[80]};
  }

  ${({ sticky }) =>
    sticky
      ? css`
          @media ${until(Device.TabletLarge)} {
            position: sticky;
            bottom: 0px;
          }
        `
      : null}
`;

const Header = styled.h2`
  ${fonts.helvetica['87-heavy-condensed']};
  font-size: 24px;
  margin-bottom: 5px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
  color: ${brand.black};
`;

const Content = styled.div``;

export const ProductDetailsContentAccordionStyles = {
  Container,
  Content,
  Header,
};
